// تسميات الخريطة: تحويل الأسماء إلى لغة الواجهة (تشكيل الحروف العربية يُفعَّل في mapLoader).
const nameExpr = (lang) =>
  lang === "ar"
    ? ["coalesce", ["get", "name:ar"], ["get", "name:nonlatin"], ["get", "name"], ["get", "name:latin"]]
    : ["coalesce", ["get", "name:en"], ["get", "name:latin"], ["get", "name"]];

export const applyMapLanguage = (map, lang) => {
  const style = map.getStyle();
  if (!style?.layers) return;
  const expr = nameExpr(lang);
  style.layers.forEach((layer) => {
    if (layer.type !== "symbol" || !layer.layout?.["text-field"]) return;
    try {
      map.setLayoutProperty(layer.id, "text-field", expr);
    } catch {
      /* بعض الطبقات لا تحتوي أسماء */
    }
  });
};
